 

 
const TermsPolicyRow = ({privacyUrlRef,termsUrlRef}) => {
 
  return (
    <span className={"term-text BODY_MEDIUM"}>
      By signing up you agree to TeachOn’s <a href={termsUrlRef.current} className={'techOnlink BODY_MEDIUM'}>Terms</a> and <a href={privacyUrlRef.current} className={'techOnlink BODY_MEDIUM'}>
      Privacy Policy</a>
    </span>
  );
}

export default TermsPolicyRow
